import { formatApiDateRangeDisplay } from '#/utils/date';

/**
 * UI range DatePicker ↔ listQuery.filters（API：`customer_order_date_from`／`_to`）。
 */
export function readCustomerOrderDateRangeFilter(filters = {}) {
  const from = filters.customerOrderDateFrom;
  const to = filters.customerOrderDateTo;

  if (!from && !to) {
    return undefined;
  }

  return {
    from: from ?? '',
    to: to ?? from ?? '',
  };
}

export function applyCustomerOrderDateRangeToFilters(filters = {}, range) {
  const next = { ...filters };

  if (!range?.from && !range?.to) {
    delete next.customerOrderDateFrom;
    delete next.customerOrderDateTo;
    return next;
  }

  const from = range.from;
  const to = range.to || range.from;

  next.customerOrderDateFrom = from || undefined;
  next.customerOrderDateTo = to || undefined;

  return next;
}

export function resolveCustomerOrderDateFilterChipDisplay(_values, ctx = {}) {
  const display = formatApiDateRangeDisplay({
    from: ctx.filters?.customerOrderDateFrom,
    to: ctx.filters?.customerOrderDateTo,
  });

  return display ? [display] : [];
}
